module.exports = __webpack_public_path__ + "static/media/img_15.56196613.png";